export const UNLINK_CONCUR = 'unlink-concur';
const unlinkConcur = () => ({ type: UNLINK_CONCUR });
export default unlinkConcur;
